import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "w-full text-center words" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" NO ACCOUNT FOR THIS ADDRESS")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" CLICK HERE TO MAKE ONE ")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay = _resolveComponent("FarmerDisplay")!
  const _component_Vault = _resolveComponent("Vault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigPane),
    _hoisted_1,
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_FarmerDisplay, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-10 box",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault, {
                  key: _ctx.farmerAcc,
                  class: "mb-10 box",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT
                }, {
                  default: _withCtx(() => [
                    (_ctx.farmerState === 'staked' && _ctx.selectedNFTs.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "refreshButton connectText is-primary mb-5 buttonBorder",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addGems && _ctx.addGems(...args)))
                        }, " Board/Deboard Selected Apes "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'unstaked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "refreshButton connectText is-primary mb-5 buttonBorder",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                        }, " Takeoff "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'staked')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "refreshButton connectText is-primary mb-5 buttonBorder",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " Land "))
                      : _createCommentVNode("", true),
                    (_ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "refreshButton connectText is-primary mb-5 buttonBorder",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End Refueling "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "refreshButton connectText is-primary mb-5 buttonBorder",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                    }, " Claim " + _toDisplayString(_ctx.availableA/1000000) + " Milez ", 1)
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "connectButton is-primary buttonBorder",
                    style: {"border-color":"black"},
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, _hoisted_11)
                ])
              ]))
        ]))
  ], 64))
}